import Vue from 'vue'
import Router from 'vue-router'
import authService from '@/api/authService'
import { clearRequests } from '@/api/api'

Vue.use(Router)

const Login = () => import(/* webpackChunkName: "Login" */'@/views/login/Login.vue')
const Reset = () => import(/* webpackChunkName: "Reset" */'@/views/reset/Reset.vue')
const Root = () => import(/* webpackChunkName: "Root" */'@/views/root/Root.vue')
const Summary = () => import(/* webpackChunkName: "Summary" */'@/views/summary/Summary.vue')
const Dashboard = () => import(/* webpackChunkName: "Dashboard" */'@/views/dashboard/Dashboard.vue')
const Campaigns = () => import(/* webpackChunkName: "campaigns" */'./views/campaigns/Campaigns.vue')
const CampaignActivation = () => import(/* webpackChunkName: "campaign-activation" */'./views/campaign-activation/CampaignActivation.vue')
const CampaignDetail = () => import(/* webpackChunkName: "campaign-detail" */'./views/campaign-detail/CampaignDetail.vue')
const CampaignCompare = () => import(/* webpackChunkName: "campaign-compare" */'./views/campaign-compare/CampaignCompare.vue')
const ChannelConfig = () => import(/* webpackChunkName: "channel-config" */'./views/channel-config/ChannelConfig.vue')
const TecnomatChannelConfig = () => import(/* webpackChunkName: "TecnomatChannelConfig" */'@/views/tecnomat-channel-config/TecnomatChannelConfig.vue')
const ChannelDashboard = () => import(/* webpackChunkName: "channel-dashboard" */'./views/channel-dashboard/ChannelDashboard.vue')
const Map = () => import(/* webpackChunkName: "Map" */'@/views/map/Map.vue')
const Locations = () => import(/* webpackChunkName: "Locations" */'@/views/locations/Locations.vue')
const LocationsList = () => import(/* webpackChunkName: "LocationsList" */'@/views/locations/locations-list/LocationsList.vue')
const CenterDetail = () => import(/* webpackChunkName: "CenterDetail" */'@/views/locations/center-detail/CenterDetail.vue')
const AdvertDetail = () => import(/* webpackChunkName: "AdvertDetail" */'@/views/locations/advert-detail/AdvertDetail.vue')
const Explore = () => import(/* webpackChunkName: "Explore" */'@/views/explore/Explore.vue')
const Admin = () => import(/* webpackChunkName: "Admin" */'@/views/admin/Admin.vue')
const TemplateDetail = () => import(/* webpackChunkName: "TemplateDetail" */'@/views/template-detail/TemplateDetail.vue')
const TemplateForm = () => import(/* webpackChunkName: "TemplateForm" */'@/views/template-form/TemplateForm.vue')
const TargetForm = () => import(/* webpackChunkName: "TargetForm" */'@/views/target-form/TargetForm.vue')
const TargetDetail = () => import(/* webpackChunkName: "TargetDetail" */'@/views/target-detail/TargetDetail.vue')
const ConfDetail = () => import(/* webpackChunkName: "ConfDetail" */'@/views/conf-detail/ConfDetail.vue')
const ConfForm = () => import(/* webpackChunkName: "ConfForm" */'@/views/conf-form/ConfForm.vue')
const Users = () => import(/* webpackChunkName: "Users" */'@/views/users/Users.vue')
const UserForm = () => import(/* webpackChunkName: "UserForm" */'@/views/user-form/UserForm.vue')
const UserDetail = () => import(/* webpackChunkName: "UserDetail" */'@/views/user-detail/UserDetail.vue')
const CenterEdit = () => import(/* webpackChunkName: "CenterEdit" */'@/views/locations/center-edit/CenterEdit.vue')
const AdvertEdit = () => import(/* webpackChunkName: "AdvertEdit" */'@/views/locations/advert-edit/AdvertEdit.vue')
const Billing = () => import(/* webpackChunkName: "Billing" */'@/views/billing/Billing.vue')
const ExteriorChannelConfig = () => import(/* webpackChunkName: "ExteriorChannelConfig" */ '@/views/exterior-channel-config/ExteriorChannelConfig.vue')
const ExteriorCampaignDetail = () => import(/* webpackChunkName: "ExteriorCampaignDetail" */ '@/views/exterior-campaign-detail/ExteriorCampaignDetail.vue')
const PoiEdit = () => import(/* webpackChunkName: "PoiEdit" */'@/views/locations/poi-edit/PoiEdit.vue')
const PoiDetail = () => import(/* webpackChunkName: "PoiDetail" */'@/views/locations/poi-detail/PoiDetail.vue')

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/admin',
      name: 'django-admin',
      beforeEnter (to, from, next) {
        window.location.href = 'https://geoxymity-posterscope-api-dev.carto.solutions/admin/'
      }
    },
    {
      path: '/reset/:token',
      name: 'reset',
      component: Reset,
      meta: { skipAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { skipAuth: true }
    },
    {
      path: '/',
      component: Root,
      children: [
        {
          path: '',
          redirect: 'summary'
        },
        {
          path: '/summary',
          name: 'summary',
          component: Summary,
          meta: {
            header: 'dark-transparent',
            iconColor: '#c9cbd1',
            filterGroups: ['dashboard_summary'],
            showDatePicker: true,
            hideSearch: true
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            showDatePicker: true,
            filterGroups: ['shops', 'dashboard'],
            hideSearch: true,
            showActiveToggle: true
          }
        },
        {
          path: '/dashboard/:type',
          name: 'channel-dashboard',
          component: ChannelDashboard,
          meta: {
            header: 'dark-transparent',
            headerFromChannelType: true,
            iconColor: '#ffffff',
            showDatePicker: true,
            filterGroups: ['shops', 'dashboard_extended'],
            hideSearch: true
          }
        },
        {
          path: '/campaigns',
          name: 'campaigns',
          component: Campaigns,
          meta: {
            showDatePicker: true,
            showActiveToggle: true,
            showTasks: true,
            filterGroups: ['shops', 'campaigns']
          },
          children: [
            {
              path: 'new',
              name: 'new-campaign',
              component: CampaignActivation
            },
            {
              path: ':campaignid',
              name: 'edit-campaign',
              component: CampaignActivation
            }
          ]
        },
        {
          path: '/campaign-detail/:campaignid',
          name: 'campaign-detail',
          component: CampaignDetail,
          meta: {
            noHeader: true,
            noFooter: true
          }
        },
        {
          path: '/exterior-campaign-detail/:campaignid',
          name: 'exterior-campaign-detail',
          component: ExteriorCampaignDetail,
          meta: {
            noHeader: true,
            noFooter: true
          }
        },
        {
          path: '/campaign-compare/:campaignsid',
          name: 'campaign-compare',
          component: CampaignCompare,
          meta: {
            noHeader: false,
            noFooter: false
          }
        },
        {
          path: '/campaigns/:campaignid/:channelid/:channeltype',
          name: 'channel-config',
          component: TecnomatChannelConfig,
          meta: {
            noHeader: true,
            noSidebar: true,
            noFooter: true
          }
        },
        {
          path: '/generic-channels/:campaignid/:channelid/:channeltype',
          name: 'channel-config',
          component: ChannelConfig,
          meta: {
            noHeader: true,
            noSidebar: true,
            noFooter: true
          }
        },
        {
          path: '/exterior-campaigns/:campaignid/:channelid/:channeltype',
          name: 'exterior-channel-config',
          component: ExteriorChannelConfig,
          meta: {
            noHeader: true,
            noSidebar: true,
            noFooter: true
          }
        },
        {
          path: '/map',
          name: 'map',
          component: Map,
          meta: {
            noFooter: true,
            noScroll: true,
            header: 'light-transparent',
            filterGroups: ['shops'],
            hideSearch: true
          },
          children: [
            {
              path: '/',
              name: 'locations',
              component: Locations,
              children: [
                {
                  path: '/',
                  name: 'locations-list',
                  component: LocationsList
                },
                {
                  path: 'center-detail/:centerid',
                  name: 'center-detail',
                  component: CenterDetail
                },
                {
                  path: 'advert-detail/:advertid',
                  name: 'advert-detail',
                  component: AdvertDetail
                },
                {
                  path: 'center-edit/:centerid',
                  name: 'center-edit',
                  component: CenterEdit
                },
                {
                  path: 'advert-edit/:advertid',
                  name: 'advert-edit',
                  component: AdvertEdit
                },
                {
                  path: 'poi-detail/:poiid',
                  name: 'poi-detail',
                  component: PoiDetail
                },
                {
                  path: 'poi-edit/:poiid',
                  name: 'poi-edit',
                  component: PoiEdit
                }
              ]
            },
            {
              path: 'explore',
              name: 'explore',
              component: Explore
            }
          ]
        },
        {
          path: '/administration',
          name: 'administration',
          component: Admin,
          meta: {
            header: 'light',
            filterGroups: ['shops', 'campaigns']
          },
          children: [
            {
              path: 'template',
              name: 'template-form',
              component: TemplateForm
            },
            {
              path: 'template/:templateid',
              name: 'template-detail',
              component: TemplateDetail
            },
            {
              path: 'template/:templateid/edit',
              name: 'template-edit',
              component: TemplateForm
            },
            {
              path: 'target',
              name: 'target-form',
              component: TargetForm
            },
            {
              path: 'target/:targetid',
              name: 'target-detail',
              component: TargetDetail
            },
            {
              path: 'target/:targetid/edit',
              name: 'target-edit',
              component: TargetForm
            },
            {
              path: 'conf/:confid',
              name: 'conf-detail',
              component: ConfDetail
            },
            {
              path: 'conf/:confid/edit',
              name: 'conf-edit',
              component: ConfForm
            }
          ]
        },
        {
          path: '/users',
          name: 'users',
          component: Users,
          meta: {
            header: 'light',
            filterGroups: ['users']
          },
          children: [
            {
              path: 'edit/:userid',
              name: 'user-form',
              component: UserForm
            },
            {
              path: 'detail/:userid',
              name: 'user-detail',
              component: UserDetail
            }
          ]
        },
        {
          path: 'billing',
          name: 'billing',
          component: Billing,
          meta: {
            noScroll: true,
            hideSearch: true,
            showDatePicker: true,
            filterGroups: ['shops']
          }
        }
      ]
    }
  ]
})

// TODO: keep checking the case for cancelating all request between nested routes
router.beforeEach(async (to, from, next) => {
  const toRoute = to.matched.slice(-1)[0] || {}
  const fromRoute = from.matched.slice(-1)[0] || {}
  if (fromRoute.parent !== toRoute) {
    clearRequests()
  }
  if (!authService.isLoggedIn() && !authService.loading) {
    await authService.restoreAuth()
  }
  if (!to.meta.skipAuth && !authService.isLoggedIn()) {
    next({ name: 'login', query: { next: to.fullPath } })
  } else {
    next()
  }
})

export default router
